module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1044.f21e7096.jpg";